/* eslint-disable react/prop-types */
import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconZoomReset = (props) => (
  <SVG
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.4179 21V18.707C17.875 19.1929 17.2725 19.6133 16.622 19.957C15.1332 20.7436 13.4548 21.0969 11.7753 20.9766C10.0962 20.8562 8.48268 20.2675 7.12098 19.2764C5.75982 18.2856 4.7039 16.933 4.07313 15.3721C3.86631 14.8602 4.11315 14.2774 4.62489 14.0703C5.13679 13.8635 5.71958 14.1103 5.92665 14.6221C6.41724 15.8363 7.23889 16.8894 8.29774 17.6602C9.35617 18.4305 10.6113 18.8877 11.9179 18.9814C13.2239 19.0751 14.5295 18.8011 15.6874 18.1895C16.2873 17.8725 16.8344 17.4703 17.3143 17H14.4179C13.8656 17 13.4179 16.5523 13.4179 16C13.4179 15.4477 13.8656 15 14.4179 15H19.4179C19.9701 15 20.4179 15.4477 20.4179 16V21C20.4179 21.5523 19.9701 22 19.4179 22C18.8656 22 18.4179 21.5523 18.4179 21ZM4.41786 3C4.41786 2.44772 4.86557 2 5.41786 2C5.97014 2 6.41786 2.44772 6.41786 3V5.29199C6.96073 4.80632 7.56348 4.38557 8.21375 4.04199C9.70242 3.25556 11.3822 2.9031 13.0614 3.02344C14.7411 3.14384 16.3535 3.7328 17.7147 4.72363C19.076 5.71453 20.1318 7.06777 20.7626 8.62891C20.9694 9.14095 20.7219 9.72379 20.2098 9.93066C19.6978 10.1374 19.115 9.88994 18.9081 9.37793C18.4175 8.1637 17.5958 7.11151 16.537 6.34082C15.4781 5.57016 14.2248 5.11123 12.9188 5.01758C11.6125 4.92394 10.3053 5.19876 9.14735 5.81055C8.54736 6.12758 8.00052 6.52961 7.5204 7H10.4179C10.9701 7 11.4179 7.44772 11.4179 8C11.4179 8.55228 10.9701 9 10.4179 9H5.41786C4.86557 9 4.41786 8.55228 4.41786 8V3Z"
      fill="white"
    />
  </SVG>
)

export default withIconStyles(IconZoomReset)
